module.exports = __webpack_public_path__ + "static/media/Oscar.1d33b364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Oscar.png
// module id = 1468
// module chunks = 0